import Navbar from '@/components/feature/Navbar';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import FeatureGrid from './components/FeatureGrid';
import ArticleCards from './components/ArticleCards';
import AboutSection from './components/AboutSection';
import TestimonialSection from './components/TestimonialSection';
import CTASection from './components/CTASection';
import FooterSection from './components/FooterSection';

export default function Home() {
  return (
    <main>
      <Navbar />
      <HeroSection />
      <CategoryGrid />
      <FeatureGrid />
      <ArticleCards />
      <AboutSection />
      <TestimonialSection />
      <CTASection />
      <FooterSection />
    </main>
  );
}